<script type="text/javascript" src="https://unpkg.com/xlsx@0.15.1/dist/xlsx.full.min.js"></script>

<template>
  <div style="margin-top: 250px">

    <Overlay v-show="showOverlay"/>

    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t("Julat Harga Min Max") }} {{ title }}
      </v-card-title>

      <v-container>
          <!-- <v-row>

            <v-col cols="12" sm="3">
              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('pusingan')"
                return-object
                :items="lookuppusingan"
                item-text="pusingan"
                v-model="pusingan"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-text-field
                outlined
                dense
                v-bind:label="$t('Kod Item')"
                v-model="kodItem"
              ></v-text-field>
            </v-col>

             <v-col cols="9" sm="1">
             <v-btn
                    color="blue white white--text"
                    @click='cari()'>
                    <span class="material-icons">search</span> 
                   {{ $t("cari") }}</v-btn>
            </v-col>
            
          </v-row> -->
          
       
        <!-- <v-row>
              <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                absolute
                color="deep-purple accent-4"
              ></v-progress-linear>
        </v-row>    -->
          <v-card-text v-show="false">
            <div class="table-container">
              <!-- <table dark fixed-header dense height="700px"> -->
              <table ref="exportable_table" id="table1">
                <thead>
                  <tr>
                    <th style="text-align:center;font-size: medium;"><strong>HID</strong></th>
                    <th style="text-align:center;font-size: medium;"><strong>Kod Item</strong></th>
                    <th style="text-align:center;font-size: medium;"><strong>Keterangan</strong></th>
                    <th style="text-align:center;font-size: medium;"><strong>Min</strong></th>
                    <th style="text-align:center;font-size: medium;"><strong>Max</strong></th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="item in dataJulatHargaMinMax" v-bind:key="item.index" @click="handleClick(item)">
                    <td>{{item.HID}}</td>
                    <td>{{item.KodItem}}</td>
                    <td>{{item.Keterangan}}</td>
                    <td>{{item.min}}</td>
                    <td>{{item.max}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>

          <v-card-text>
             <v-card>
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn 
                    @click="downloadExcel('xlsx')" 
                    color="primary"
                    dense
                    rounded
                  > 
                  Download
                </v-btn>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="dataJulatHargaMinMax"
                :search="search"
              ></v-data-table>
            </v-card>
          </v-card-text>
        
      </v-container>
    </v-card>
  </div>
</template>
<script>
import Overlay from '../../components/Overlay'
import i18n from "@/i18n";
import axios from "../../plugins/axios";
import hidServices from "@/services/lookupField";
const negerilookup = new hidServices();
import getPusingan from "@/services/pusingan";
const pusingan = new getPusingan();

export default {
components: {
  Overlay
},
async beforeMount(){
   
  
},
  Name: "Kadarrespon",
  
  computed: {},
  setup() {},
  data: () => ({
    search:'',
    userDetail:'',
    loading: false,
    showOverlay: false,
    
    ///////////link untuk ke page/////////////////////
    item: [
      {
        text: i18n.t("utama"),
        disabled: false,
        href: `paparanutama`,
      },
      {
        text: `${i18n.t("kadarrespon")}`,
        disabled: true,
        href: "",
      },
    ],
    title: "",
   
    lookupnegeri: [],
    sample: "",
    paparpusinganexport: "",
    lookuppusingan: [],
    lookupsample: [],
    sortedData:[],
    paparnegeriexport: "",
    disablepusingan: true,
    peranan: "",
    disablenegeri: true,
    disablesample: true,
    R:"",
    detailNegeri:"",

    kodItem: '',
    pusingan:'',
    dataJulatHargaMinMax:[],
    detailData:[],
    detailDataByHID:[],

    headers: [
        {
          text: 'HID',
          align: 'start',
          filterable: false,
          value: 'HID',
        },
        { text: 'Kod Item', value: 'KodItem' },
        { text: 'Keterangan', value: 'Keterangan' },
        { text: 'Min', value: 'min' },
        { text: 'Max', value: 'max' },
      ],
    
  }),
  async mounted() {
    var listPusingan = await pusingan.getPusinganDataAll();
    this.lookuppusingan = listPusingan;

    this.lookupsample = await pusingan.getSample();

    this.$store.dispatch("localStorageuser");
    this.userDetail = this.$store.state.localStorageuser;

    this.getData();

    
  },
  methods: {
    goToRoute(url) {
      return `/${i18n.locale}/${url}`;
},
     
  async getData() {
    this.showOverlay = true;
    try {
        const res = await axios.post(`${process.env.VUE_APP_API_URL}/julatHarga/getDataMinMax`,{
          pusingan : this.pusingan,
          kodItem : this.kodItem
        });

        var dataz = res.data.data;
        this.dataJulatHargaMinMax = dataz;
        this.showOverlay = false;
      
    } catch (error) {
      this.errorDialog = true;
      setTimeout(() => (this.errorDialog = false), 2000);
      this.errMessage = "getData : " + error;
    }

  },

  handleClick(data){
    // this.detailData = data;
    // this.getDetailDataByHID(data);

  },

  convertTarikh(data){
    if(data != undefined){
      var convertDate =  new Date(data);
      return convertDate.toISOString().split('T')[0]; 
    } 
  },
  

  downloadExcel(type, fn, dl){
      
    var elt = this.$refs.exportable_table;
    var wb = XLSX.utils.table_to_book(elt, {sheet:"JulatMinMax"});

    XLSX.write(wb, {bookType:type, bookSST:true, type: 'base64'})
    XLSX.writeFile(wb, fn || ('JulatMinMax.' + (type || 'xlsx')));

  },
  
  
//   downloadExcel: function () {
    
//     var uri = 'data:application/vnd.ms-excel;base64,';
  
//     var base64 = function(s) {
//         return window.btoa(unescape(encodeURIComponent(s)))
//       },
//       format = function(s, c) {
//         return s.replace(/{(\w+)}/g, function(m, p) {
//           return c[p];
//         })
//       }
//     var sTable = document.getElementById("table1").innerHTML;;
//     var ctx = {
//       worksheet: 'JulatMaxMin',
//       table: sTable
//     };
 
//     var style = "<style>";
//     style = style + "body {font: 12px Calibri;}";
//     style = style + "table {width: 100%; font: 12px Calibri;}";
//     style = style + "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
//     style = style + "padding: 2px 3px;text-align: center;}";
//     style = style + "</style>";

//     var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
//     tab_text = tab_text + '<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';

//     tab_text = tab_text + '<x:Name>JulatMaxMin</x:Name>';

//     tab_text = tab_text + '<x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>';
//     tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
   
//     tab_text = tab_text + (style); 
//     tab_text = tab_text + (sTable);  

//     tab_text = tab_text + '</body></html>';
   
//     var link = document.createElement("a");
//     link.download = "JulatMaxMin.xls";
//     link.href = uri + base64(format(tab_text, ctx))
//     link.click();
 
//     // window.location.href = uri + window.btoa(tab_text);
  
// },
},
  
    watch:{
    paparnegeriexport(val){ 
      this.detailNegeri = val; 
    },
  }
};
</script>
<style scoped>
.table-container {
  position: relative;
  max-height: 700px;
  width: 100%;
  overflow: scroll;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin: 50px auto;
}

tbody {
  overflow: scroll;
  height: 250px;
}
/* tr {
  background: #eee;
} */

td,
th {
  padding: 10px;
  border: 1px solid #ccc;
  text-align: left;
  font-size: 18px;
}
</style>